<template>
    <div id="app" :class="{'poster-page': url === '/poster'}" v-cloak v-show="isShow">
        <base-nav v-if="$store.state.app.is_show1 &&$store.state.app.is_show && Authorization" :isCoolart="url.indexOf('coolart') === 1"></base-nav>
        <base-crumbs v-if="$store.state.app.is_show" :crumbs="[]" :isCoolart="url.indexOf('coolart') === 1"></base-crumbs>
        <div id="height">
            <keep-alive>
                <router-view v-if="isUrl(url)"></router-view>
            </keep-alive>
            <router-view v-if="!isUrl(url)"></router-view>
        </div>
        <base-footer v-if="$store.state.app.is_show && Authorization"></base-footer>
        <base-Photobrowser :imgData="$store.state.app.listsImg" :param="$store.state.app.paramImg" :index.sync="$store.state.app.indexImg" v-if="$store.state.app.indexImg >= 0"></base-Photobrowser>
        <!-- <base-vip :popup="$store.state.app.vip_popup" v-if="$store.state.app.vip_popup"></base-vip> -->
        <base-add-cart :popup="$store.state.app.cart_popup" v-if="$store.state.app.cart_popup"></base-add-cart>
    </div>
</template>

<script>
    import {LoginStatus} from 'hanzi-vue-package';
    import baseNav from '@components/Navigation';
    import baseFooter from '@components/Footer';
    import baseCrumbs from '@components/Crumbs';
	import baseVip from '@components/vip.vue';
	import baseAddCart from '@components/addCart.vue';
    import basePhotobrowser from '@components/photobrowser/Photobrowser.vue'

    export default {
        data(){
            return {
                Authorization: tools.url.params('Authorization'),
                // Desc:tools.url.params('Desc'),
                url: location.pathname,
                isShow: false,  //页面是否显示
                name: tools.cache.get('nickname'),
            }
        },
        created(){
            let that = this;

            /*
                **混合 （请认真查看使用方法 https://vuefe.cn/v2/guide/mixins.html）
                **注意同名钩子函数将混合为一个数组，因此都将被调用。且先调用混合对象的钩子
                **
            */
            tools.vue.mixin({
                /* 全局方法 */
                methods: {
                    /* 默认图片过滤 */
                    thumbnail: function (val, size) {
                        let img_size = '?x-oss-process=image/resize,w_' + size; // + '/auto-orient,1';
                        return !val ? '/static/images/hanzi_logo.png' : val + (!size ? '' : img_size);
                    },

                    /* 跳转 */
                    toUrl: function (url, val) {
                        tools.router.push({path: url, query: val});
                    },
                    open(url, val) {
                        window.open(tools.url.replaceParamVals(val, location.origin + url));
                    },
                    back() {
                        tools.router.back();
                    }
                    // replace(url, val) {
                    //     tools.router.replace({path: url, query: val});
                    // }
                },
                /* 全局过滤 */
                filters: {
                    /* 默认图片过滤 */
                    thumbnail: function (val, size) {
                        let img_size = '?x-oss-process=image/resize,w_' + size; // + '/auto-orient,1';
                        return !val ? '/static/images/hanzi_logo.png' : val + (!size ? '' : img_size);
                    },

                    /* 时间转换 */
                    timeTran: function (value) {
                        return parseInt(value) === 0 ? '-' : tools.date('Y-m-d H:i:s', value);
                    },

                    /* 时间转换为年月日（带中文） */
                    timeDate: function (value) {
                        return parseInt(value) === 0 ? '-' : tools.date('Y'+ '年' + 'm' + '月' + 'd' + '日', value);
                    },

                    /* 自定时间格式转换 */
                    setTimeTran: function (value, type) {
                        return parseInt(value) === 0 ? '-' : tools.date(type, value);
                    },

                    NumberToChinese: (num)=>{
                        num = num.replace(/0/g, '零');
                        num = num.replace(/1/g, '一');
                        num = num.replace(/2/g, '二');
                        num = num.replace(/3/g, '三');
                        num = num.replace(/4/g, '四');
                        num = num.replace(/5/g, '五');
                        num = num.replace(/6/g, '六');
                        num = num.replace(/7/g, '七');
                        num = num.replace(/8/g, '八');
                        num = num.replace(/9/g, '九');
                        return num;
                    },

                    /* 价格转换--保留两位小数 */
                    toFixedPrice : function (value) {
                        return value ? (parseInt(value) / 100).toFixed(2) : '0';
                    },

                    /* 价格转换 */
                    toPrice: function (value) {
                        return value ? (parseInt(value) / 100) : '0';
                    },

                    price (n) {
                        let b=(parseInt(n) / 100).toString();
                        let len=b.length;
                        if(len<=3){return n > 0 ? b : '-';}
                        let r=len%3;
                        return r>0?b.slice(0,r)+","+b.slice(r,len).match(/\d{3}/g).join(","):b.slice(r,len).match(/\d{3}/g).join(",");
                    },
                }
            });

        },
        name: 'app',
        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'isLinkChange'
        },
        methods: {
            setMainHeight: function () {
                let minHeight = $(window).height() - 100;
                let mainHeight = '';

                if (this.$route.path === '/poster') {
                    let posterMinHeight = 560;
                    let navHeight = $('.head-nav-wrap').outerHeight() || 0;
                    let footerHeight = $('[i="footer_wrap"]').outerHeight() || 0;

                    minHeight = Math.max($(window).height() - navHeight - footerHeight, posterMinHeight);
                    mainHeight = minHeight + 'px';
                }

                $("#height").css({
                    "min-height": Math.max(minHeight, 0) + 'px',
                    "height": mainHeight
                });
            },
            isUrl(url, type) {
                const listArt = [
                    '/works/index',
                    '/coolart/goods/list',
                    '/participatingartists/index'
                ];

                let that = this,
                    sym = '==',
                    noLoginUrls = '';

                if(type){
                    sym = type;
                }

                for(let i = 0; i < listArt.length; i++){

                    if(i === 0){
                        noLoginUrls += `"${url}"${sym}"${listArt[i]}"`;
                    }else if(i == listArt.length-1){
                        noLoginUrls += `||"${url}"${sym}"${listArt[i]}"`;
                    }else{
                        noLoginUrls += `||"${url}"${sym}"${listArt[i]}"`;
                    }
                }

                return eval(noLoginUrls);
            },

            /* 连接变化时执行 */
            toUrl: function (url, val) {
                tools.router.push({path: url, query: val});
            },
            isLinkChange: function () {
                let that = this;
                // console.log('改变了导航:',this.$route);
                if(that.$route.path!='/media/download' && that.$route.path!='/about'){
                    tools.cache.del('currentPage'); /* 删除媒体中心新闻当前页 */
                }
                that.$store.state.app.footer = 0;
                that.$store.state.app.nav_type === null;
                that.$store.state.app.crumbs = [];

                that.Authorization = tools.cache.get('Authorization');

                that.url = location.pathname;

			    $(window).scrollTop(0)

			    that.$nextTick(() => {
                    setTimeout(() => {
                        that.setMainHeight();
                    }, 10);
                });
                if (!that.isHavePage()) {
                    return;
                }

                that.name = tools.cache.get('nickname'); //用户名

                setTimeout(() => {
                    $('img').removeAttr('title');
                    $('a').removeAttr('title');
                }, 2000);

                //判断是否为登陆页
                // if(!(that.$route.path == '/login' || that.$route.path == '/register' || tools.noLoginUrl.isUrl(that.$route.path))){
                //
                //     //每次跳页面都会验证登录是否过期
                //     LoginStatus.check({
                //         type:  'login'
                //     });
                //
                // }

                that.isShow = true;
            },

            /* 判断页面是否存在 */
            isHavePage:function () {

                //首页跳过
                if (this.$route.path == '/') {
                    return true;
                }

                //首页跳过
                if (this.$route.path == '/404') {
                    this.isShow = true;
                    return false;
                }

                //注册页跳过
                if (this.$route.path == '/register') {
                    this.isShow = true;
                    return false;
                }

                //不存在自动跳转到404页面
                if (this.$route.matched.length < 1) {
                    tools.router.replace('/404');
                    return false;
                }

                this.isfullScreen = false;
                return true;
            },

            navBlock:function (type) {
                this.isNavBlock = type;
            },

            /* 注销登录 */
            logOut: function () {
                tools.alert.loading();
                tools.ajax({
                    url: '/api/login/out',
                    ajaxData: {},
                    successFun: function (res) {
                        tools.alert.closeLoading();
                        tools.cache.del('nickname');
                        tools.cache.del('Authorization');
                        tools.cache.set('isLogin', '0');

                        that.toUrl('/login');
                    },
                    errorFun: function (error_data, status, headers, error_obj) {
                        tools.alert.closeLoading();
                        tools.alert.error(error_data.error_msg);
                    },
                    type: 'DELETE'
                });

            },

            /* 跳转 */
            toUrl: function (url, val) {
                tools.router.push({path: url, query: val});
            }
        },
        components: {
            baseNav,
            baseFooter,
            baseVip,
            baseCrumbs,
            basePhotobrowser,
            baseAddCart
        },
        beforeCreate(){

        },
        beforeDestroy(){
            $(window).off('resize.appHeight');
            $(document).off('fullscreenchange.appHeight webkitfullscreenchange.appHeight mozfullscreenchange.appHeight MSFullscreenChange.appHeight');
        },
        mounted(){
            this.isHavePage();
            let that = this;
            let updateHeight = function () {
                that.setMainHeight();
            };
            console.log(that.$store.state.app.is_show);
//         document.onkeydown=function(){
//			    var e = window.event||arguments[0];
//			    if(e.keyCode==123){
//			            return false;
//			    }else if((e.ctrlKey)&&(e.shiftKey)&&(e.keyCode==73)){
//			            return false;
//			    }else if((e.ctrlKey)&&(e.keyCode==85)){
//			            return false;
//			    }else if((e.ctrlKey)&&(e.keyCode==83)){
//			           return false;
//			    }
//			}
//			document.oncontextmenu=function(){
//			    return false;
//			}
            that.$nextTick(() => {
                setTimeout(() => {
                    that.setMainHeight();
                }, 10);
            });

            $(window).off('resize.appHeight').on('resize.appHeight', updateHeight);
            $(document).off('fullscreenchange.appHeight webkitfullscreenchange.appHeight mozfullscreenchange.appHeight MSFullscreenChange.appHeight')
                .on('fullscreenchange.appHeight webkitfullscreenchange.appHeight mozfullscreenchange.appHeight MSFullscreenChange.appHeight', function () {
                    setTimeout(updateHeight, 100);
                });
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    @import "assets/sass/common/tool";

    #app.poster-page {
        [i="footer_wrap"] {
            min-width: 1280px;
        }
    }
</style>



// WEBPACK FOOTER //
// App.vue?747439c3